<template>
    <div id="creditChangesDiv"  class="vs-con-loading__container">
        <vs-table ref="creditChangesTable" :data="tableData" pagination search :maxItems="itemsPerPage">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=3">
                            <span>3</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=250">
                            <span>250</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=500">
                            <span>500</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=1000">
                            <span>1000</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="time">Time</vs-th>
                <vs-th sort-key="credits">Credits</vs-th>
                <vs-th sort-key="add_type">Type</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].time">
                        {{ moment(data[index].time).format("YYYY/MM/DD HH:mm:ss") }}
                    </vs-td>

                    <vs-td :data="data[index].credits">
                        {{ data[index].credits }}
                    </vs-td>

                    <vs-td :data="data[index].add_type">
                        <vs-chip color="primary" v-if="data[index].add_type === 0">Added by admin</vs-chip>
                        <vs-chip color="success" v-else-if="data[index].add_type === 1">Added by reseller</vs-chip>
                        <vs-chip color="warning" v-else-if="data[index].add_type === 3">Self service</vs-chip>
                        <vs-chip color="danger" v-else>Unknown</vs-chip>
                    </vs-td>

                </vs-tr>
            </template>
        </vs-table>
    </div>
</template>
<script>

    export default {

        props: {

            clientId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

                itemsPerPage: 3,
                isMounted: false,

                changes: []
            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#creditChangesDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const channelsPromise = this.$http.get('/api/management/v1/client/' + this.clientId + '/credits')
                channelsPromise.then(function(response) {
                    thisIns.changes = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#creditChangesDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.creditChangesTable.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.creditChangesTable.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.changes
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }

    }

</script>
